/**
 * Creates a ref callback that merges multiple refs.
 * Useful when forwarding refs and also needing to track the element in a local ref.
 *
 * @param localRef - A ref object to update with the node
 * @param forwardedRef - A React ref (function or ref object) to forward to
 * @returns A callback function that updates both refs
 */
export function createMergedRef(localRef, forwardedRef) {
    return (node) => {
        localRef.current = node;
        if (typeof forwardedRef === 'function') {
            forwardedRef(node);
        }
        else if (forwardedRef) {
            forwardedRef.current = node;
        }
    };
}
